import React, { useEffect } from "react";
import { Navigate, useNavigate, useLocation } from "react-router-dom";

import sessionService from "@services/session.service";
import { routeMap } from "@utils/constants";
import { useConfigStore } from "@stores/useConfigStore";
import { ReminderNotifications } from "@components/reminder/reminder-notifications";
import { useGlobalInformationStore } from "@stores/global_informationStore";
import commonService from "@services/common.service";
import _ from "lodash";
import { getPasswordSecret } from "@utils/helpers";
import storage from "@services/storage.service";
import { MembersProvider } from "@pages/members/useMembers";

type AuthGaurdProps = {
  children: any;
};

var CryptoJS = require("crypto-js");

const AuthGaurd = ({ children }: AuthGaurdProps) => {
  const fetchConfig = useConfigStore((state) => state.fetchConfig);
  const config = useConfigStore((state) => state.config);
  const loader = useConfigStore((state) => state.loader);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    console.log("AuthGaurd.useEffect1");
    if (!sessionService.token) {
      navigate(routeMap["login"]);
    }
  }, [navigate]);

  useEffect(() => {
    console.log("AuthGaurd.useEffect2");
    if (sessionService.token) {
      fetchConfig();
    }
  }, [fetchConfig]);

  const setsecrets = useGlobalInformationStore((state) => state.setsecrets);
  useEffect(() => {
    const token = storage.get("_token");
    const refreshToken = storage.get("_refreshToken");

    if (token && refreshToken) {
      commonService.getKeyVaultValues(["MapAPIKey", "PdfPassword"]).subscribe({
        next: (res: any) => {
          let values: any = {};
          _.forIn(res.data?.data?.values || {}, (value, key) => {
            values[key] = CryptoJS.AES.decrypt(value, getPasswordSecret()).toString(CryptoJS.enc.Utf8);
          });
          setsecrets(values);
        },
        error: (err) => {
          console.log("Secrets error", err);
        },
      });
    }
  }, []);

  if (!sessionService.token) {
    let forcedLogout = sessionStorage.getItem("forcedLogout") === "true";
    if (!forcedLogout) {
      sessionStorage.setItem("redirectURL", `${location.pathname}${location.search}`);
    }
    return <Navigate to="/auth/login" />;
  }

  if (loader || !config) {
    <p>loading..</p>;
  }

  return <ReminderNotifications>{children}</ReminderNotifications>;
};

const Wrapper: React.FC<any> = function ({children}) {
  return (
    <MembersProvider >
      <AuthGaurd children={children}/>
    </MembersProvider>
  )
};

export default Wrapper;
